import { render, staticRenderFns } from "./qInstructionPopup.vue?vue&type=template&id=e7adbea4&scoped=true&"
import script from "./qInstructionPopup.vue?vue&type=script&lang=js&"
export * from "./qInstructionPopup.vue?vue&type=script&lang=js&"
import style0 from "./qInstructionPopup.vue?vue&type=style&index=0&id=e7adbea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7adbea4",
  null
  
)

export default component.exports